module.exports = __webpack_public_path__ + "img/guide_1.0563ce62.png";